import { Button } from '@thoughtspot/radiant-react/widgets/button/button';
import { MultiSelectButton, } from '@thoughtspot/radiant-react/widgets/button/multi-select-button';
import cx from 'classnames';
import React, { useMemo } from 'react';
import styles from './create-import-split-button.module.scss';
export const CreateImportSplitButton = ({ createLabel, onCreate, importLabel, onImport, isImportEnabled, className, createTestId, importMenuItemId = 'import', }) => {
    const config = useMemo(() => ({
        primaryButton: {
            text: createLabel,
            type: 'primary',
            onClick: onCreate,
            'data-testid': createTestId,
        },
        actionsMenuConfig: [
            {
                id: importMenuItemId,
                label: importLabel,
                onClick: onImport,
            },
        ],
        isDropdownDisabled: false,
        className: cx(styles.splitButton, className),
    }), [
        createLabel,
        onCreate,
        createTestId,
        importMenuItemId,
        importLabel,
        onImport,
        className,
    ]);
    if (!isImportEnabled) {
        return (React.createElement(Button, { type: "primary", text: createLabel, onClick: onCreate, "data-testid": createTestId }));
    }
    return React.createElement(MultiSelectButton, { ...config });
};
//# sourceMappingURL=create-import-split-button.js.map